import React, {useEffect, useState} from "react";
import axios from "axios";
import {Navigate, redirect} from "react-router";
import AppBar from "./../AppBar";

export function RemoteStatus({address, port}) {

    const [z690, setZ690] = useState('...');

    useEffect(() => {
        // POST request using axios inside useEffect React hook
        const payload = { data: 'Z690A_IS_ONLINE' };
        axios.post('/checkz690', payload)
            .then((response) => { setZ690(response.data)})
            .catch(() => {setZ690("ERROR")
                ;})



// empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);

    if (z690==="ERROR") return <Navigate to={"/signin"} />
    else
        return (
        <div className="App">
        <AppBar position="static"></AppBar>
            <p>Host : {address} port : {port} is now {z690}</p>

        </div>
    );

}

export default RemoteStatus;

